module.exports = __webpack_public_path__ + "img/dashboard_active.ed707d0e.svg";